<ng-template>
  <div class="relative flex flex-col justify-between w-full p-4 bg-white rounded overflow-auto">
    <div class="mb-2 text-lg font-medium">
      <div class="header-width">
        <ng-content select="[modal-header]"></ng-content>
      </div>
      @if (canDismiss) {
        <div class="absolute right-1 top-1">
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>

    <div class="max-w-2xl break-words">
      @if (!data?.content) {
        <ng-content></ng-content>
      }
      @if (data?.content) {
        <p>{{ data.content }}</p>
      }
    </div>

    <div class="mt-3 text-right">
      <ng-content select="[modal-buttons]"></ng-content>
    </div>
  </div>
</ng-template>
